module.exports = __webpack_public_path__ + "img/TACOS.10ab3cf5.png";